import InputIban from 'components/interaction/InputIban/index.jsx';
import Select from 'components/tags/Select/index.jsx';
import currencies from 'utils/currencies/index.js';
import messages from './messages.js';

const schema = {
  id: 'payment-accounts',
  properties: [
    {
      id: 'iban',
      label: messages.iban,
      as: InputIban,
      required: true,
    },
    {
      id: 'name',
      label: messages.accountName,
      type: 'text',
      required: true,
    },
    {
      id: 'currency',
      label: messages.currency,
      as: Select,
      attributes: { className: 'w-50', options: [{ value: '', label: 'Select...' }, ...currencies.options] },
      required: true,
      type: 'text',
    },
  ],
};

export default schema;
